import React from "react";
import { Formik, Form, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import InputField from "components/fields/InputField";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login } from "../../store/reducers/userSlice";
import { API_POST__VERIFY_OTP } from "api/auth";
import { API_POST__RESET_PASSWORD } from "api/auth";
import { toast } from "react-toastify";

const VerifyOTPSchema = Yup.object().shape({
    email: Yup.string().required("Email is required"),
    new_password: Yup.string().required("Password is required"),



});

export default function ResetPassword() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
        try {
            const userData = await API_POST__RESET_PASSWORD(values);
            console.log("API_POST__RESET_PASSWORD", userData)
            toast.success(userData?.message)
            // localStorage.setItem("userData", JSON.stringify(userData?.data));
            // Perform OTP verification logic here
            // For now, just navigate to dashboard
            navigate("/auth/sign-in");

        } catch (error) {
            toast.error(error?.response?.data?.message)
            console.error("Error:", error);
            setFieldError("otp", "Invalid OTP");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div className="mt-16 mb-16 flex h-full w-full items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start">
            <div className="mt-[2vh] w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 xl:max-w-[420px]">
                <h4 className="mb-2.5 text-4xl font-bold text-navy-700 dark:text-white">
                    Reset Password
                </h4>
                <p className="mb-9 ml-1 text-base text-gray-600">
                    Enter the OTP sent to your email.
                </p>

                <Formik
                    initialValues={{ new_password: "", email: "" }}
                    validationSchema={VerifyOTPSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isSubmitting }) => (
                        <Form>
                            <Field
                                className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                                variant="auth"
                                extra="mb-3"
                                label="Email"
                                placeholder="Email"
                                name="email"
                                type="text"
                            />
                            <ErrorMessage
                                name="email"
                                component="div"
                                className="text-red-500"
                            />
                            <Field
                                className="mt-2 flex h-11 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none"
                                variant="auth"
                                extra="mb-3"
                                label="Password*"
                                placeholder="123456"
                                name="new_password"
                                type="text"
                            />
                            <ErrorMessage
                                name="new_password"
                                component="div"
                                className="text-red-500"
                            />

                            <button
                                type="submit"
                                disabled={isSubmitting}
                                className="linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
                            >
                                {isSubmitting ? "Reseting..." : "Reset Password"}
                            </button>
                        </Form>
                    )}
                </Formik>
                {/* 
        <div className="mt-4">
          <span className="text-sm font-medium text-navy-700 dark:text-gray-600">
            Didn't receive the OTP?{" "}
          </span>
          <a
            href=" "
            className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white"
          >
            Resend OTP
          </a>
        </div> */}
            </div>
        </div>
    );
}
